module.exports = __webpack_public_path__ + "static/media/Formular-Bold.6b34b02f.woff";